export default {
  dropdown: require('../assets/icons/ic_dropdown.png'),
  check: require('../assets/icons/ic_check.png'),
  copy: require('../assets/icons/ic_copy.png'),
  next: require('../assets/icons/ic_next.png'),
  error: require('../assets/icons/ic_error.png'),
  more: require('../assets/icons/ic_more.png'),
  clock: require('../assets/icons/ic_clock.png'),
  eye: require('../assets/icons/ic_eye.png'),
  eyeOff: require('../assets/icons/ic_eye_off.png'),
}
